import { Link } from "react-router-dom";
import shubhamPhoto from "@/assets/shubham-borkar.webp";

export function FounderNote() {
  return (
    <div className="max-w-[720px]">
      <div className="mt-10">
        <div className="space-y-5 text-[17px] leading-[1.65] text-[var(--sn-fg2)]">
          <p>
            I spent a few years inside an institution doing equity research the slow way. Today, AI
            changes the unit economics of research forever. This club exists to give independent
            analysts, founders and investors the same edge, without an institution, without a team
            of twenty, without an eight-figure data budget.
          </p>
          <p>
            Just reproducible playbooks, honest conversation, and a small group of people who care
            about doing this well.
          </p>
          <div className="flex flex-wrap items-center gap-x-5 gap-y-2 border-t border-[var(--sn-border)] pt-5">
            <img src={shubhamPhoto} alt="" aria-hidden className="h-10 w-10 rounded-full object-cover" />
            <span className="text-[15px] font-medium text-foreground">Shubham Borkar</span>
            <Link
              to="/shubham-borkar"
              className="text-[14.5px] font-medium text-foreground transition-colors hover:text-primary"
              
            >
              About the founder →
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}